import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericDocContainerModel, GenericDocHdrLineOpenQueueContainerModel, GenericDocHdrLineOpenQueueImportContainerModel, GenericDocumentHdrLineContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { GenericDocSearchCriteriaDtoModel, GenericDocumentCloneDTO, GenericDocumentPutDTO, ReturnSalesInvoiceDtoModel } from '../../../data-transfer-objects';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


export class BaseGenDocTypeService extends BaseApiPublicLoginTemplateService<GenericDocContainerModel, GenericDocContainerModel, GenericDocContainerModel> {

  public docType: string;

  constructor(http: HttpClient, docType: string) {
    super();
    this.docType = docType;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX;
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}${this.docType}`;
    this.endpoint_path_login_entity_url = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}${this.docType}` + '/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }

  getGenericDocumentHdrLineByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocumentHdrLineContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-lines/${this.docType}`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocumentHdrLineContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  getByCustomSnapshotLinesQuery(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-lines/${this.docType}` + '/type/snapshot/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getByCustomSnapshotLinesCountQuery(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-lines/${this.docType}` + '/type/snapshot-total-records/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getGenericDocHdrLineLinkByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocumentHdrLineContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-line-links/${this.docType}`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocumentHdrLineContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }
  getGenericDocHdrLineLinkQueueByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocHdrLineOpenQueueContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-line-link-open-queues/${this.docType}`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocHdrLineOpenQueueContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  getGenericDocHdrLineLinkQueueBySnapshot(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-line-link-open-queues/${this.docType}`;
    }
    const UrlByCriteria = this.apiUrl + '/custom/query/snapshotHdrLineOpenQueues/backoffice-ep';
    return this.httpClient.post<ApiResponseModel<any>>(
      UrlByCriteria,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getGenericDocHdrLinesLinkQueueBySnapshot(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-line-link-open-queues/${this.docType}`;
    }
    const UrlByCriteria = this.apiUrl + '/custom/query/snapshotHdrLinesOpenQueues/backoffice-ep';
    return this.httpClient.post<ApiResponseModel<any>>(
      UrlByCriteria,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getGenericDocHdrLineLinkImportByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocHdrLineOpenQueueImportContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}hdr-imports/${this.docType}`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocHdrLineOpenQueueImportContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  voidGenericDocument(dtoObject: Object, apiVisa: ApiVisa, guid: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/backoffice-ep/void/' + guid,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

  discardGenericDocument(apiVisa: ApiVisa, guid: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/discard/backoffice-ep/' + guid,
      null, //empty body
      this.getHttpHeader(apiVisa)
    );
  }

  public createTemp(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/temp/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public updateAutoFinal(genericDocumentContainer: any, validateStockBalance: boolean, validateSNForSignumZero: boolean, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    let formData = {
      "validateSNForSignumZero": validateSNForSignumZero,
      "validateStockBalance": validateStockBalance,
      "genericDocumentContainer": genericDocumentContainer
    }
    this.apiUrl += "/update-auto-final/backoffice-ep";
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public updateSettlementMethods(genericDocumentContainer: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    this.apiUrl += "/update-settlement-methods/backoffice-ep";
    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl,
      genericDocumentContainer,
      this.getHttpHeader(visa)
    );
  }

  public cloneDocument(dto: GenericDocumentCloneDTO, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/clone/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.post<BasicApiResponseModel<GenericDocumentCloneDTO>>(
      this.apiUrl, dto, this.getHttpHeader(visa)
    );
  }

  public getOutstandingItems(dto: any, visa: ApiVisa): Observable<ApiResponseModel<ReturnSalesInvoiceDtoModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/outstanding-items/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl, dto, this.getHttpHeader(visa)
    );
  }

  getOpenCreditGenDocHdrGuids(docCcy: string, entityHdrGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<string[]>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}`;
    }
    const url = this.apiUrl + 'open-credit/login-entity-ep?docCcy=' + docCcy + '&entityHdrGuid=' + entityHdrGuid;
    return this.httpClient.get<BasicApiResponseModel<string[]>>(url, this.getHttpHeader(visa));
  }

  getGenDocHdrGuidsByGenDocPgwQueryDto(genDocArapPgwQueryDto: any, entityHdrGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<string[]>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}`;
    }
    const url = this.apiUrl + 'pgw-merchant/login-entity-ep/query?entityHdrGuid=' + entityHdrGuid;
    return this.httpClient.post<BasicApiResponseModel<string[]>>(url, genDocArapPgwQueryDto, this.getHttpHeader(visa));
  }

  public getGrossProfit(dto: any, visa: ApiVisa): Observable<ApiResponseModel<ReturnSalesInvoiceDtoModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + Core2Config.ERP_PREFIX + 'gen-doc/reports/gross-profits/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl, dto, this.getHttpHeader(visa)
    );
  }
}
